import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, TextField, Button, Paper } from '@mui/material';
import { useUser } from '../hooks/Authorize';
import axios from 'axios';
import { isOrgBasedApp, provisionOrganization } from '../services/provisioningService';

const SetupFlow = () => {
  const [searchParams] = useSearchParams();
  const planId = searchParams.get('planId');
  const navigate = useNavigate();
  const platformUser = useUser();

  const [status, setStatus] = useState('initializing'); 

  useEffect(() => {
    const startProvisioning = async () => {
      if (!planId) {
        navigate('/myStore');
        return;
      }

      try {
        const response = await axios.get(`/store/plan/${planId}`);
        if (response.data.success) {
          const planData = response.data.data;

          if (isOrgBasedApp(planData.type)) {
            setStatus('provisioning');
            
            const orgId = await provisionOrganization(planData.type, platformUser._id, { 
              firstName: platformUser.firstName || platformUser.fullName?.split(' ')[0] || platformUser.username || 'User',
              email: platformUser.email || platformUser.recoveryEmail,
              planName: planData.name
            });
            
            navigate(`/offer-payment?planId=${planId}&orgId=${orgId}`);
          } else {
            navigate(`/offer-payment?planId=${planId}`);
          }
        } else {
          navigate('/myStore');
        }
      } catch (error) {
        console.error('Setup flow error:', error);
        setStatus('error');
      }
    };

    if (platformUser?._id) {
      startProvisioning();
    }
  }, [planId, platformUser, navigate]);

  if (status === 'error') {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="80vh">
        <Typography variant="h5" color="error" mb={2}>
          Something went wrong during setup.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/myStore')}>
          Back to Store
        </Button>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="80vh">
      <CircularProgress size={60} sx={{ mb: 4 }} />
      <Typography variant="h5" fontWeight="500">
        {status === 'provisioning' ? 'Setting up your workspace...' : 'Initializing...'}
      </Typography>
      <Typography variant="body2" color="text.secondary" mt={1}>
        We're preparing everything for you. This will only take a moment.
      </Typography>
    </Box>
  );
};

export default SetupFlow;
